module.exports = __webpack_public_path__ + "static/media/Internationalpic1@3x.77cf19b1.png";